/* eslint-disable key-spacing */
export const defaultCheckBoxTheme = {
  disabled:                 'disabled',
  input:                    'checkbox-input',
  label:                    'checkbox-label',
  semi:                     'semi',
  wrapper:                  'checkbox-wrapper',
};
/* eslint-enable key-spacing */
